module.exports = __webpack_public_path__ + "img/12.279f95cf.jpg";